module.exports = ".sidebar {\r\n    width: 300px;\r\n}\r\n\r\n.active_sub_menu{\r\n    background: #42b7cb;\r\n    color: #fff;\r\n    border-radius: 3px;\r\n}"